import $ from "jquery";
import "slick-carousel";

$(function () {
	$(".frontpage-carousel")
		.slick({
			dots: true,
			settings: {
				infinite: false,
				speed: 300,
				slidesToShow: 2,
				slidesToScroll: 1,
				centerMode: true,
				variableWidth: true,
			},
		})
		.on("setPosition", function (event, slick) {
			slick.$slides.css("height", slick.$slideTrack.height() + "px");
		});
});
